const WORDMARK_COLORS = [
  "#3E9ED6", "#35B3E0", "#A06BE0", "#E06BB8", "#EC6198", "#F0706E", "#F59045",
  "#F5B02E", "#E8C45A", "#EFC33E", "#EFC33E", "#F2BC3E", "#F5AC3E", "#F0A43E",
  "#E89C3E", "#35C4C9", "#359FD6", "#3E8FD0", "#47A3D6",
];

export const Wordmark = ({ className = "" }) => {
  let ci = 0;
  return (
    <span
      className={`uppercase leading-none ${className}`}
      style={{ letterSpacing: "0.1em" }}
      data-testid="brand-wordmark"
    >
      {"Infinity & Beyond Care".split("").map((ch, i) => {
        if (ch === " ") return <span key={i}> </span>;
        const color = WORDMARK_COLORS[ci++];
        return (
          <span key={i} style={{ color }}>
            {ch}
          </span>
        );
      })}
    </span>
  );
};

export const InfinityMark = ({ className = "h-10 w-10" }) => (
  <img src="/logo-mark.png" alt="" aria-hidden="true" className={className} />
);

export default InfinityMark;
